import { render, staticRenderFns } from "./Home-Propietario.vue?vue&type=template&id=90346b48&"
import script from "./Home-Propietario.vue?vue&type=script&lang=js&"
export * from "./Home-Propietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports